var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfirmationIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "95px",
    viewBox: "0 0 95 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "92CC8AAC-2F47-476C-9E7F-EB83648CC003") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finmatic/Register/phone-number/dropdown",
    transform: "translate(-672.000000, -267.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(523.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lock",
    transform: "translate(149.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 47
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(35.000000, 24.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,43 C26,44.657 24.657,46 23,46 L3,46 C1.343,46 0,44.657 0,43 L0,3 C0,1.343 1.343,0 3,0 L23,0 C24.657,0 26,1.343 26,3 L26,43 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 8,
    x2: 25,
    y2: 8,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2969,
    y1: 3.6025,
    x2: 13.2969,
    y2: 3.6025,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 42,
    x2: 15,
    y2: 42,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 38,
    x2: 25,
    y2: 38,
    id: "Stroke-9"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "42.4444444 45.5299947 46.9173006 50 53.5555556 40"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfirmationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/confirmation-icon.39b09c422e3dd674bc4e507f22bca002.svg";